// function load_cart(){
//   fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
//   .then((response) => response.text())
//   .then((responseText) => {
//     const cartid = 'cart-drawer';
//     const html = new DOMParser().parseFromString(responseText, 'text/html')  
//     const destination = document.querySelector('.cart-sidebar');
//     const source = html.getElementById(cartid);
//     if (source && destination) destination.innerHTML = source.innerHTML;
//     // document.querySelectorAll('.item-remove').forEach(function(cartRemove){
//     //   var data_line = cartRemove.dataset.line;      
//     //   cartRemove.addEventListener('click',(evt) => removeItem(data_line));
//     // });
//     document.querySelectorAll('.item-remove').forEach(function(btn){
//         btn.addEventListener('click', function(){
//           const itemKey = this.dataset.key;
//           removeItemByKey(itemKey);
//         });
//       });

//     document.querySelectorAll('.header-cart').forEach(function(cartButton){
//       cartButton.addEventListener('click',function(e){
//         document.querySelector('body').classList.add('open-drawer');
//         document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
//       });
//     });
//     document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
//       cartButton.addEventListener('click',function(e){
//         document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
//       });
//     });
//     const url = '/cart.js';
//     fetch(url)
//     .then((resp) => resp.json())
//     .then(function(data) {
//       var cart_count = data.item_count;
//       if(cart_count>0){
//       	document.querySelector('.cart-count').innerHTML = cart_count;
//       }else{
//       	document.querySelector('.cart-count').innerHTML = '';
//       }
//     })
//     .catch(function(error) {
//       console.log(error);
//     })
//   });
// }
// load_cart();

// // function removeItem(data_line){
// //   const data = {'line': data_line ,'quantity': 0 };
// //   fetch('/cart/change.js', {
// //     method: 'POST',
// //     headers: {
// //       'Content-Type': 'application/json',
// //     },
// //     body: JSON.stringify(data),
// //   })
// //   .then((response) => response.json())
// //   .then((data) => {
// //     load_cart();
// //   })
// //   .catch((error) => {
// //     console.error('Error:', error);
// //   });
// // }

// function removeItemByKey(clickedKey){

//   fetch('/cart.js')
//   .then(res => res.json())
//   .then(cart => {

//     const clickedItem = cart.items.find(item => item.key === clickedKey);
//     if(!clickedItem) return;

//     const unitKey = clickedItem.properties ? clickedItem.properties.unit_key : null;

//     // If no unit_key → remove only this item
//     if(!unitKey){
//       return removeSingleItem(clickedKey);
//     }

//     // Find all items with same unit_key
//     const matchedItems = cart.items.filter(item => 
//       item.properties && item.properties.unit_key === unitKey
//     );

//     // Remove one by one (sequentially safer)
//     let chain = Promise.resolve();

//     matchedItems.forEach(item => {
//       chain = chain.then(() => {
//         return fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             id: item.key,
//             quantity: 0
//           })
//         });
//       });
//     });

//     chain.then(() => {
//       load_cart();
//     });

//   });
// }


// function removeSingleItem(key){
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       id: key,
//       quantity: 0
//     })
//   }).then(() => {
//     load_cart();
//   });
// }



function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {

    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);

    if (source && destination) destination.innerHTML = source.innerHTML;

    document.querySelectorAll('.item-remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        const itemKey = this.dataset.key;
        removeItemByKey(itemKey);
      });
    });

    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
      });
    });

    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });

    fetch('/cart.js')
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      document.querySelector('.cart-count').innerHTML = cart_count > 0 ? cart_count : '';
    })
    .catch(function(error) {
      console.log(error);
    });

  });
}

load_cart();

function removeItemByKey(clickedKey){

  fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {

    const clickedItem = cart.items.find(item => item.key === clickedKey);
    if(!clickedItem) return;

    const unitKey = clickedItem.properties ? clickedItem.properties._unit_key : null;

    if(!unitKey){
      return removeSingleItem(clickedKey);
    }

    const matchedItems = cart.items.filter(item => 
      item.properties && item.properties._unit_key === unitKey
    );

    let updates = {};

    matchedItems.forEach(item => {
      updates[item.key] = 0;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(() => {
      load_cart();
    });

  })
  .catch(err => console.error(err));
}

function removeSingleItem(key){

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: key,
      quantity: 0
    })
  })
  .then(() => {
    load_cart();
  });

}
